import { createApiRequestActions } from '@ackee/redux-utils';

import * as types from './types';

export { types };

export const fetchDeliveryPartners = createApiRequestActions<undefined, undefined, { lastSuccessAt: string }, string>(
    types.fetchDeliveryPartners,
);
